export function ProductCode({ code, className = '' }: { code: string; className?: string }) {
  return <span className={className}>{code}</span>;
}
